import { render } from "./ProductDetail.vue?vue&type=template&id=70fb2e6a&scoped=true"
import script from "./ProductDetail.vue?vue&type=script&lang=js"
export * from "./ProductDetail.vue?vue&type=script&lang=js"

import "@/assets/css/layout_product.css?vue&type=style&index=0&id=70fb2e6a&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70fb2e6a"]])

export default __exports__